// Generated by ReScript, PLEASE EDIT WITH CARE


function importCss(param) {
  return (require(`OrderDashboardAssets/styles/_order-fare-dashboard-main.scss`));
}

export {
  importCss ,
  
}
/* No side effect */
